<template>
  <div>
    <div v-if="!loading">
      <v-tooltip bottom v-if="remove">
        <v-btn flat icon color="red" slot="activator" @click="doRemove()" class="tableActionBtn">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <span>{{removeText}}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="review">
        <v-btn flat icon color="blue" slot="activator" @click="doReview()" class="tableActionBtn">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <span>{{reviewText}}</span>
      </v-tooltip>
      <v-tooltip bottom v-if="query">
        <v-btn flat icon color="teal" slot="activator" @click="doQuery()" class="tableActionBtn">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <span>{{queryText}}</span>
      </v-tooltip>
      <slot>
      </slot>
    </div>
    <div v-else>
      <v-progress-circular indeterminate color="primary" :size="20" :width="2"></v-progress-circular>
    </div>
  </div>
</template>

<script>
// Commonly used action
export default {
  data() {
    return {

    }
  },
  methods: {
    doQuery() {
      this.$emit('query', this.rowData)
    },
    doReview() {
      this.$emit('review', this.rowData)
    },
    doRemove() {
      this.$emit('remove', this.rowData)
    }
  },
  props: {
    rowData: {
      type: Object,
      default: () => { }
    },
    query: {
      type: Boolean,
      default: false
    },
    review: {
      type: Boolean,
      default: false
    },
    remove: {
      type: Boolean,
      default: false
    },
    queryText: {
      type: String,
      default: 'Query'
    },
    reviewText: {
      type: String,
      default: 'Review'
    },
    removeText: {
      type: String,
      default: 'Remove'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.tableActionBtn {
  margin: 2px;
}
</style>
